import LetterAvatar from "@/components/Avatar/LetterAvatar"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import StatusBadge from "@/components/ui/badge"
import CodeFormat from "@/components/ui/code"
import { formatToDevanagariStyle } from "@/utilities/helper"
export const columns = [
  {
    header: "Code",
    cell: ({ row }) => <CodeFormat value={row.original.code} />,
  },
  {
    header: "Customer",
    cell: ({ row }) => (
      <LetterAvatar
        name={row.original.customer?.name}
        subtitle={row.original.customer?.phone}
      />
    ),
  },
  {
    header: "Sales Date",
    cell: ({ row }) => (
      <span className="whitespace-nowrap">{row.original.order_date}</span>
    ),
  },
  {
    header: "Sales Date Nepali",
    cell: ({ row }) => (
      <span className="whitespace-nowrap">
        {row.original.order_date_nepali}
      </span>
    ),
  },
  {
    header: "Method",
    cell: ({ row }) =>
      row.original.payment_method_id ? row.original.payment_method : "MULTIPLE",
  },
  // {
  //   header: "Status",
  //   cell: ({ row }) => <StatusBadge name={row.original.status_parsed} />,
  // },
  {
    header: "Payment Status",
    cell: ({ row }) => <StatusBadge name={row.original.payment_status} />,
  },
  {
    header: "Sales Status",
    cell: ({ row }) => <StatusBadge name={row.original.sales_status} />,
  },
  {
    header: "Total",
    cell: ({ row }) => (
      <>
        Rs. {formatToDevanagariStyle(row.original.total_amount)}
        {row.original.sales_return_total > 0 && (
          <div>
            - Rs.
            {formatToDevanagariStyle(row.original.sales_return_total)}
          </div>
        )}
      </>
    ),
  },
]
